import { FIELDS } from '@/pages/Invoices/components/InvoiceLines/constants';

const defaultFields = [
  {
    key: 'Id',
    field: FIELDS.ID,
    title: 'Line No',
    label: 'Line No',
    cell: 'navigation',
    sortable: true,
    hidden: false,
    width: 70,
  },
  {
    title: 'Qty',
    field: FIELDS.QUANTITY,
    width: 100,
  },
  {
    title: 'Part Number',
    field: FIELDS.PART_NUMBER,
    width: 200,
  },
  {
    title: 'Description',
    field: FIELDS.DESCRIPTION,
    width: 300,
  },
  {
    title: 'Mfr',
    field: FIELDS.MFR,
    width: 150,
  },
  {
    title: 'Date Code',
    field: FIELDS.DATE_CODE,
    width: 150,
  },
  {
    title: 'Lot Code',
    field: FIELDS.LOT_CODE,
    width: 150,
  },
  {
    title: 'Condition',
    field: FIELDS.CONDITION_NAME,
    width: 150,
  },
  {
    title: 'Price',
    field: FIELDS.PRICE,
    cell: 'formatCurrency',
    width: 100,
  },
  {
    title: 'Class',
    field: FIELDS.CLASS,
    width: 100,
  },
  {
    title: 'Package',
    field: FIELDS.PACKAGE,
    width: 100,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
];

export default defaultFields;
